import React, { useMemo } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useEmpresasCliente } from "./empresasCadastradasData";
import { useNavigate } from "react-router-dom";

// ======================= Tipos =======================
type Cliente = {
  cnpj: string;
  razao_social: string; // <<< NOVO
  nome_fantasia: string;
  email?: string | null;
  telefone?: string | null;
};

type Row = React.ReactNode[];

// ======================= Utils =======================
function onlyDigits(s: string) {
  return String(s || "").replace(/\D+/g, "");
}

function formatCNPJ(cnpj: string) {
  const d = onlyDigits(cnpj).padStart(14, "0").slice(-14);
  // 00.000.000/0000-00
  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

/** Normaliza quando a página receber dados "crus" (array direto ou {data:[]}) */
function normalizeClientes(raw: any): Cliente[] {
  if (!raw) return [];
  const arr = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.data)
    ? raw.data
    : [];
  return (arr as any[]).map((x) => ({
    cnpj: x.cnpj ?? x.CNPJ ?? "",
    razao_social:
      x.razao_social ?? x.razaoSocial ?? x.razao ?? x.razao_social_nome ?? "",
    nome_fantasia:
      x.nome_fantasia ?? x.nomeFantasia ?? x.fantasia ?? x.nome ?? "",
    email: x.email ?? x.mail ?? null,
    telefone: x.telefone ?? x.tel ?? x.phone ?? null,
  }));
}

// ======================= Página =======================
const EmpresasClientes: React.FC = () => {
  const headers = useMemo(
    () => ["CNPJ", "Razão Social", "Nome Fantasia", "E-mail", "Telefone"],
    []
  );

  //            CNPJ      Razão Social   Nome Fantasia  E-mail     Telefone
  const columnWidths = useMemo(
    () => ["180px", "360px", "300px", "280px", "180px"],
    []
  );

  // Hook de dados
  const hook = useEmpresasCliente?.();
  const data = normalizeClientes((hook as any)?.data ?? hook);

  const rows: Row[] = useMemo(() => {
    return data.map((c) => [
      formatCNPJ(c.cnpj || ""),
      c.razao_social || "-", // <<< NOVO
      c.nome_fantasia || "-",
      c.email && String(c.email).trim() ? String(c.email).trim() : "-",
      c.telefone && String(c.telefone).trim() ? String(c.telefone).trim() : "-",
    ]);
  }, [data]);

  const navigate = useNavigate();

  return (
    <div>
      <TitleButtons
        title="Recursos Humanos - Empresas/clientes"
        buttons={[
          {
            label: "Registrar Empresa",
            onClick: () =>
              navigate("/coordenacao/empresas-cadastradas/registrar-empresa"),
            variant: "primary",
          },
        ]}
      />

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        responsiveWidths={{
          // índices 0..4: 0 CNPJ, 1 Razão Social, 2 Nome Fantasia, 3 E-mail, 4 Telefone
          1300: {
            1: "300px", // Razão Social
            2: "240px", // Nome Fantasia
            3: "220px", // E-mail
          },
          1000: {
            0: "160px", // CNPJ
            1: "220px", // Razão Social
            2: "0px", // esconde Nome Fantasia em telas muito estreitas
            3: "0px", // esconde E-mail em telas muito estreitas
            4: "140px", // Telefone
          },
        }}
      />
    </div>
  );
};

export default EmpresasClientes;
